import React, { useState } from "react";

const Offer = ({}) => {
  return (
    <div className="agency-search-bar">
      <input
        type="text"
        placeholder="Effectuer une recherche par code postal, ville..."
        className="agency-search-input"
      />
      <button className="agency-search-btn">Rechercher</button>
    </div>
  );
};

export default Offer;
